<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          柏致堂
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
          欢迎使用八万互联门诊医疗管理系统
          </b-card-title>
          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="账户"
                label-for="username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="账户"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="username"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="username"
                    placeholder="请输入您的账户"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="password">密码</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="密码"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? false:null"
                  >
                    <b-form-input
                      id="password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="password"
                      placeholder="请输入您的密码"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- captcha -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">验证码</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="验证码"
                  vid="captcha"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="captcha"
                      v-model="captcha"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge h65"
                      name="captcha"
                      placeholder="请输入验证码"
                    />
                    <b-input-group-append is-text>
                      <div v-html="captchaimg" @click="refreshCaptcha"></div>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  记住密码
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                登录
              </b-button>
            </b-form>
          </validation-observer>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardTitle, BImg, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
import { required, email  } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import router from '@/router'
export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      username: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rules
      required,
      email,
      captcha: '',
      captchaUrl: '',
      captchaimg: '',
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    this.refreshCaptcha()
  },
  setup() {
  },
  methods: {
    refreshCaptcha(){
      this.$api.sysusers.getcaptcha().then(res=>{
        this.captchaimg = res.data.data
      })
    },
    
  login() {
      const userpwd = {
        username : this.username,
        password : this.password,
        captcha  : this.captcha,
      }
      this.$api.sysusers.login(userpwd).then(res =>{
        const {token, userData, status} = res.data
        let message = '账户密码有误'
        if(status==401){
          this.refreshCaptcha()
          message = '验证码有误';
        } 
        if(status==200){
          localStorage.setItem('token', token)
          localStorage.setItem('userData', JSON.stringify(userData))
          const {role} = JSON.parse(localStorage.getItem('userData'))
          store.dispatch("routes/fetchMenus",role).then(()=>{
            router.addRoutes(store.state.routes.routes)
            store.dispatch('notice/fetchNotice')
            store.dispatch('systeminfo/fetchSysteminfo')
            this.$router.push({ name: 'dash' }).catch(err => { console.log(err) })
          }).catch(err => { console.log(err) })
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: '欢迎登录',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: "使用八万互联门诊管理系统",
              },
            })
        }else{
          this.refreshCaptcha()
          this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: message,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: '请输入正确的账户密码',
              },
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.h65{
  height: 65px;
}
</style>
